import { useState } from 'react'
import { useGetSocialSigninStartUrlLazyQuery } from '@sketch/gql-types'
import { useToast } from '@sketch/toasts'
import { localStorageKeys } from '@sketch/constants'
import { setItem } from '@sketch/utils'
import * as Sentry from '@sentry/browser'

export const useGetSocialSignIn = () => {
  const { showToast } = useToast()
  const [isPersistentLoading, setIsPersistentLoading] = useState(false)

  const [getSocialSigninStartUrl, { loading: mutationLoading }] =
    useGetSocialSigninStartUrlLazyQuery({
      onCompleted: data => {
        const { url, state } = data.socialSigninStartUrl

        /** "state" is used to get the proper JWT token for some providers. */
        state && setItem(localStorageKeys.socialState, state)
        window.location.href = url
      },
      onError: ({ message }) => {
        setIsPersistentLoading(false)
        showToast('Something went wrong', 'negative')
        Sentry.captureMessage(`Social Sign In Error: ${message}`)
      },
    })

  const handleGetSocialSigninStartUrl = (
    ...args: Parameters<typeof getSocialSigninStartUrl>
  ) => {
    setIsPersistentLoading(true)
    return getSocialSigninStartUrl(...args)
  }

  return {
    getSocialSigninStartUrl: handleGetSocialSigninStartUrl,
    loading: isPersistentLoading || mutationLoading,
  }
}
